import { supabase } from "../lib/supabase";

const API_BASE = process.env.REACT_APP_API_BASE || "";

export async function fetchComments(articleId) {
  const res = await fetch(
    `${API_BASE}/api/comments?article_id=${encodeURIComponent(articleId)}`
  );
  if (!res.ok) throw new Error("Failed to fetch comments");
  return res.json();
}

export async function addComment(articleId, body) {
  const {
    data: { session },
  } = await supabase.auth.getSession();
  const token = session?.access_token;

  if (!token) {
    throw new Error("Nicht angemeldet. Bitte melde dich an.");
  }

  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  const res = await fetch(`${API_BASE}/api/comments`, {
    method: "POST",
    headers,
    body: JSON.stringify({ article_id: articleId, body }),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || "Failed to add comment");
  }
}
